import { BodyText, LayoutBox } from '@bamboohr/fabric';
import { FunctionComponent } from 'react';

const FieldSubnote: FunctionComponent<
	React.PropsWithChildren<DynamicForm.FieldSubnoteProps>
> = ({ text }) => {
	return (
		<LayoutBox marginTop="8px">
			<BodyText color="neutral-weak" size="extra-small">
				{text}
			</BodyText>
		</LayoutBox>
	);
};

export default FieldSubnote;
